import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

const applicationId = process.env.REACT_APP_DD_APPLICATION_ID ?? '';
const clientToken = process.env.REACT_APP_DD_CLIENT_TOKEN ?? '';

if (applicationId !== '' && clientToken !== '') {
  datadogRum.init({
    applicationId,
    clientToken,
    site: process.env.REACT_APP_DD_SITE ?? 'us3.datadoghq.com',
    service: process.env.REACT_APP_DD_SERVICE ?? 'triggeremail-reg',
    env: process.env.REACT_APP_DD_ENV ?? 'reg',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    defaultPrivacyLevel: 'mask-user-input',
    plugins: [reactPlugin()],
  });
}

export { datadogRum };
